import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import React from "react";
import ProductGstCreate from "../ProductGstCreate";

const ProductGstDialog = ({
  open,
  handleClose,
  product = null,
  gst = null,
}) => {
  
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading={gst ? "Update gst" : "Add gst"}
    >
      <Box sx={{ overflow: "hidden", padding: 3 }}>
        <ProductGstCreate gst={gst} product={product} fullGrid={false} />
      </Box>
    </CustomDialog>
  );
};

export default ProductGstDialog;
